// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"component---src-pages-about-tsx","218":"component---src-pages-404-tsx","246":"component---src-templates-details-page-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"49":"a64dc81b1957284789b8","218":"a94d563f01535590b1f1","246":"0290531b0bb20115c7ca","691":"607d1478bf06d3882730"}[chunkId] + ".js";
};